import React from 'react'
import _ from 'lodash'
import TabPanel from './Tabs/TabPanel'
import {Grid} from '@material-ui/core'

const TabAdditionalFields = ({data = {}, ...root}) => {
  const {additional_fields = []} = data || {}
  return (
    <TabPanel {...root} style={{overflow: 'hidden'}}>
      <Grid container className="ap-mb-28">
        {_.map(additional_fields || [], (v, i) => {
          return (
            <Grid item xs={6}>
              <div class="col-style">
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <span className="tab-label-value ap-m-0 ap-typography ap-typography--sm">
                      {v.field_name}
                    </span>
                  </Grid>
                  <Grid item xs={9} style={{paddingLeft: 55}}>
                    {!_.isNil(v.value) && (
                      <span className="tab-label ap-m-0 ap-typography ap-typography--xs ap-typography--gray">
                        {v.value}
                      </span>
                    )}
                    {_.isNil(v.value) && (
                      <span className="tab-label ap-m-0 ap-typography ap-typography--xs ap-typography--gray">
                        n/a
                      </span>
                    )}
                  </Grid>
                </Grid>
              </div>
            </Grid>
          )
        })}
      </Grid>
    </TabPanel>
  )
}

export default TabAdditionalFields
